import React from 'react';
import PropTypes from 'prop-types';
import { Modal, Button } from 'react-bootstrap';

const CustomModal = ({
    show,
    handleClose,
    title,
    useCbFunc = false,
    variant = 'info',
    buttonVText = 'Validate',
    cbFunc,
    body,
    children,
    size,
    footerCenter,
}) => {
    return (
        <>
            <Modal size={size} show={show} onHide={handleClose}>
                <Modal.Header closeButton>
                    <Modal.Title>{title}</Modal.Title>
                </Modal.Header>
                <Modal.Body>{body ? body : children}</Modal.Body>
                <Modal.Footer className={!!footerCenter && 'justify-content-center'}>
                    <Button variant="secondary" onClick={handleClose}>
                        Close
                    </Button>
                    {useCbFunc === true && (
                        <Button variant={variant} onClick={cbFunc}>
                            {buttonVText}
                        </Button>
                    )}
                </Modal.Footer>
            </Modal>
        </>
    );
};

CustomModal.propTypes = {
    size: PropTypes.oneOf(['sm', 'lg', 'xl']),
    show: PropTypes.bool.isRequired,
    footerCenter: PropTypes.bool,
    handleClose: PropTypes.func.isRequired,
    title: PropTypes.string.isRequired,
    useCbFunc: PropTypes.func,
    variant: PropTypes.string,
    buttonVText: PropTypes.string,
    cbFunc: PropTypes.func,
    body: PropTypes.string,
    children: PropTypes.oneOfType([PropTypes.elementType, PropTypes.element, PropTypes.node]),
};

export default CustomModal;
